export const GET_REQUEST = 'payment/GET_REQUEST'
export const GET_SUCCESS = 'payment/GET_SUCCESS'
export const GET_FAILURE = 'payment/GET_FAILURE'
export const PUT_REQUEST = 'payment/PUT_REQUEST'
export const PUT_SUCCESS = 'payment/PUT_SUCCESS'
export const PUT_FAILURE = 'payment/PUT_FAILURE'

